<div class="modal-header">
    <h4 class="modal-title">{{ 'EMAIL_MODAL.TITLE' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()" [disabled]="isLoading">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="alert alert-info" role="alert">
        <strong>{{ 'EMAIL_MODAL.BOOKING_ID' | translate }}:</strong> {{ bookId || 'N/A' }}
    </div>
    
    <div class="form-group">
        <label for="recipientEmail">{{ 'EMAIL_MODAL.RECIPIENT_LABEL' | translate }}</label>
        <input type="email" class="form-control" id="recipientEmail" [(ngModel)]="to_address"
            [placeholder]="'EMAIL_MODAL.RECIPIENT_PLACEHOLDER' | translate" required [disabled]="isLoading" autofocus>
    </div>
    
    <!-- Loading indicator -->
    <div *ngIf="isLoading" class="text-center my-3">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">{{ 'EMAIL_MODAL.LOADING_SR' | translate }}</span>
        </div>
        <p class="mt-2 text-muted">{{ 'EMAIL_MODAL.LOADING_TEXT' | translate }}</p>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()" [disabled]="isLoading">
        {{ 'COMMON.CLOSE' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="send()" [disabled]="isLoading || !to_address">
        <span *ngIf="!isLoading">
            <i class="fas fa-paper-plane"></i> {{ 'EMAIL_MODAL.SEND_BUTTON' | translate }}
        </span>
        <span *ngIf="isLoading">
            <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
            {{ 'EMAIL_MODAL.SENDING_BUTTON' | translate }}
        </span>
    </button>
</div>